import React from 'react';
import { Container, Button } from 'react-bootstrap';

export default function StepFinalBachilleratoCompleto({ reset }) {
  return (
    <Container className="form-container text-center">
      <h2 className="form-title">Bachillerato finalizado</h2>
      <p>
        Según tus respuestas ya finalizaste el Bachillerato, por lo que la propuesta de 3F no aplica a tu caso. Si hubo un error en las respuestas y aún tenés materias pendientes, por favor realizá una nueva postulación.
      </p>
      <Button variant="primary" onClick={reset} className="mt-3 botonfinalreiniciar">
        Reiniciar formulario
      </Button>
    </Container>
  );
}
